module.exports = __webpack_public_path__ + "static/media/ECO.f00a851b.svg";